import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CheckTickets from '../../containers/CheckTicketsContainer'
import { brandStyles, clientUrl, drawDate, logoNode, money, moneyCents, prizePoolMessage } from './V2Helpers'
import V2PoweredBy from './V2PoweredBy'
import V2RefreshStrip from './V2RefreshStrip'

const prizeSizeClass = (value) => {
    const amount = Math.abs(Number(value || 0))
    if (amount >= 1000000) return " v2-prize-pill--xl"
    if (amount >= 100000) return " v2-prize-pill--long"
    return ""
}

class V2EventPage extends Component {
    state = {
        showCheckTickets: false
    }

    closeCheckTickets = () => {
        this.setState({ showCheckTickets: false })
    }

    render() {
        const { client, event } = this.props
        const brand = brandStyles(client, event)
        const completed = event.completed || event.status === "complete"
        const closed = event.status === "draw-ready" || event.drawPending
        const prizePool = Number(event.prizePool || 0)
        const splitPool = prizePool / 2
        const cause = event.cause || (client && client.name) || "your organisation"
        const eventTitle = event.name || event.title || "Community 50-50 Raffle"
        const winningTicket = event.winningTicket ? event.eventId + "_" + event.winningTicket : null
        const prizePoolTarget = money(event.maxPrizePool)
        const supportMessage = prizePoolMessage(client, event)
        const backgroundStyle = {
            backgroundImage: brand.backgroundUrl ? "url(" + brand.backgroundUrl + ")" : undefined,
            "--v2-primary": brand.primaryColor,
            "--v2-secondary": brand.secondaryColor
        }
        const overlayStyle = {
            backgroundColor: brand.overlayColor,
            opacity: brand.overlayOpacity
        }

        return (
            <div className="v2-public-page" style={backgroundStyle}>
                <V2RefreshStrip />
                <div className="v2-public-overlay" style={overlayStyle} />
                    <CheckTickets
                    v2
                    show={this.state.showCheckTickets}
                    onHide={this.closeCheckTickets}
                    eventId={event.eventId}
                    winningTicketId={event.winningTicket} />
                <main className="v2-public-content">
                    {logoNode(client, event, "v2-public-logo")}
                    <h1>{eventTitle}</h1>
                    {event.eventId ? <p className="v2-public-event-id"><span>Event ID </span><span className="v2-event-id-value">{event.eventId}</span></p> : null}
                    {event.isMajorLottery && event.majorLotteryLicense ? (
                        <p className="v2-public-event-id"><span>Major Lottery Licence </span><span className="v2-event-id-value">{event.majorLotteryLicense}</span></p>
                    ) : null}
                    <div className="v2-live-label"><span /> {completed || closed ? "Final prize pool" : "Live prize pool"}</div>
                    <div className={`v2-prize-pill${prizeSizeClass(prizePool)}`}>{money(prizePool)}</div>
                    <div className="v2-draw-copy">
                        {completed
                            ? "Draw completed" + (event.completedAt ? " on " + drawDate(event.completedAt) : "")
                            : closed
                            ? "Ticket sales have closed. The winning ticket has not been drawn yet."
                            : "Winner drawn when prize pool reaches " + prizePoolTarget + (event.drawDate ? " or on " + drawDate(event.drawDate) : "")}
                    </div>
                    <p className="v2-support-copy">
                        {completed
                            ? "This event has now closed. Thanks to everyone who supported " + cause + "."
                            : closed
                            ? "This raffle is closed for ticket sales. Please check back after the draw for the winning ticket."
                            : supportMessage}
                    </p>
                    {completed && winningTicket ? <p className="v2-extended-copy">Winning ticket {winningTicket}</p> : null}
                    {event.extendedInformation ? <p className="v2-extended-copy">{event.extendedInformation}</p> : null}
                    <section className="v2-split-pools">
                        <article className="v2-split-pool v2-split-pool--winner">
                            <span>Winner</span>
                            <strong>{moneyCents(splitPool)}</strong>
                        </article>
                        <article className="v2-split-pool v2-split-pool--cause">
                            <span>{cause}</span>
                            <strong>{moneyCents(splitPool)}</strong>
                        </article>
                    </section>
                    {!completed && !closed ? (
                        <button className="v2-primary-action" onClick={() => this.props.history.push("/" + clientUrl(client) + "/buy")}>
                            Buy tickets
                        </button>
                    ) : null}
                    <div className="v2-secondary-actions">
                        <button onClick={() => this.setState({ showCheckTickets: true })}>Check my ticket</button>
                        <button onClick={() => this.props.history.push("/" + clientUrl(client) + "/events")}>Past events</button>
                    </div>
                    <V2PoweredBy />
                </main>
            </div>
        )
    }
}

export default withRouter(V2EventPage)
